var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.11,
    height: 8.326,
    viewBox: "0 0 12.11 8.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffd355;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.028 1.535)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M339.392,147.586l4.083,2.581V144.9Z",
    transform: "translate(-339.392 -144.896)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.535)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,144.9v5.271l4.083-2.581Z",
    transform: "translate(0 -144.896)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.023 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.291,80H1.694a.748.748,0,0,0-.734.644l6.032,3.974,6.032-3.974A.748.748,0,0,0,12.291,80Z",
    transform: "translate(-0.96 -80)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.024 4.681)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.334,277.921l-1.071.705a.38.38,0,0,1-.416,0l-1.071-.706-4.752,3.006a.746.746,0,0,0,.733.639h10.6a.746.746,0,0,0,.733-.639Z",
    transform: "translate(-1.024 -277.92)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMail);
export default __webpack_public_path__ + "static/media/Footer_mail.b15797c4a4caf74845ab4f95130d0645.svg";
export { ForwardRef as ReactComponent };